// Copyright 2024 Sorama B.V.

export class Point2 {
    public readonly x: number;

    public readonly y: number;

    constructor(x: number, y: number) {
        this.x = x;
        this.y = y;
    }

    public static Add(a: Point2, b: Point2): Point2 {
        return new Point2(a.x + b.x, a.y + b.y);
    }

    public static Subtract(a: Point2, b: Point2): Point2 {
        return new Point2(a.x - b.x, a.y - b.y);
    }

    public static Multiply(a: Point2, b: number): Point2 {
        return new Point2(a.x * b, a.y * b);
    }

    public static Distance(a: Point2, b: Point2): number {
        const diff = Point2.Subtract(b, a);
        return Math.sqrt(diff.x * diff.x + diff.y * diff.y);
    }
}
